<template>
  <div>
    <transition name="view">
      <prohibited v-if="prohibited" v-on:show-who="showWho"></prohibited>
      <who v-if="who" :id="id" v-on:show-prohibited="showProhibited" v-on:show-details="showDetails"></who>
      <delivery-details
        v-if="delivery_details"
        :id="id"
        v-on:show-who="showWho"
        v-on:show-payment="showPayment"
        v-on:close-all="showProhibited"
        v-on:details="addToDetails"
      ></delivery-details>
      <payment
        v-if="payment"
        :id="id"
        :details="details"
        v-on:show-details="showDetails"
        v-on:show-summary="showSummary"
      ></payment>
      <order-summary v-if="summary" :id="id" v-on:show-payment="showPayment"></order-summary>
    </transition>
  </div>
</template>

<script>
import DeliveryDetails from '../components/Arrange/DeliveryDetails.vue'
import OrderSummary from '../components/Arrange/OrderSummary.vue'
import Payment from '../components/Arrange/Payment.vue'
import Prohibited from '../components/Arrange/Prohibited.vue'
import Who from '../components/Arrange/Who.vue'
export default {
  components: { Prohibited, Who, DeliveryDetails, Payment, OrderSummary },
  props: {
    id: [String, Number]
  },
  data() {
    return {
      prohibited: true,
      who: false,
      delivery_details: false,
      payment: false,
      summary: false,
      details: {}
    }
  },
  methods: {
    showWho(val) {
      this.neutral()
      this.who = val
    },
    showProhibited(val) {
      this.neutral()
      this.prohibited = val
    },
    showDetails(val) {
      this.neutral()
      this.delivery_details = val
    },
    neutral() {
      this.prohibited = false
      this.who = false
      this.delivery_details = false
      this.payment = false
      this.summary = false
    },
    showPayment(val) {
      this.neutral()
      this.payment = val
    },
    showSummary(val) {
      this.neutral()
      this.summary = val
    },
    addToDetails(val) {
      this.details = val
    }
  },
  beforeMount() {
    this.$store.dispatch('arrange_details/getPricing')
  },
  mounted() {
    this.$store.dispatch('middleware/isLoggedIn')
  }
}
</script>
